var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor"},[(_vm.$router.history.current.path != '/')?_c('span',[_c('Player')],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }